import { CommonStatusStep } from '.';
import { CompanyType } from '..';

// https://mdm.woa.com/static/aip/CustomerManagerAPI.html/
// MDM审核状态
export enum MDMAuthStatus {
  ApprovalVerify = 0,
  UnderReview = 1,
  Approved = 2,
  ApprovalFailed = -1,
}

// current only support: china local
export enum CompanyRegion {
  ChinaLocal = 1,
  ChinaHongKong = 2,
  ChinaTaiWan = 3,
  Overseas = 10,
}

export interface IAPICompanyRes {
  approval?: IAPICompanyApprovalInfo;
  company?: IAPICompanyInfo;
  studioCertRes?: IInternalStudioCertifiedModel;
  certifiedType?: StudioCertifiedType;
  isCertified?: boolean;
  mdmUnderReview?: boolean;
}

export interface IAPICommonCosConfigRes {
  bucket: string;
  region: string;
  uploadDir: string;
}

export interface IAPIAdminCompanyListRes {
  approvalRes: ReadonlyArray<IAPICompanyApprovalInfo>;
  companyRes: ReadonlyArray<IAPICompanyInfo>;
  studioCertRes: ReadonlyArray<IInternalStudioCertifiedModel>;
}

export interface IAPIAdminCompanyInfoRes {
  company?: IAPICompanyInfo;
  approve?: IAPICompanyApprovalInfo;
  studioCertRes?: IInternalStudioCertifiedModel;
  validateCertInfo?: IInternalStudioCertifiedModel | IAPICompanyInfo;
  isCertified: boolean;
  certifiedType?: StudioCertifiedType;
}

// 内部工作室，用户认证记录 start -----------------------------
export interface IInternalStudioUserCertRecordModel {
  readonly id: number;
  readonly StudioID: string;

  // 认证模式，目前内部认证只有kpi code，既默认
  readonly CertMode: InternalStudioCertMode;

  // 认证模式具体的填写信息 json string
  // InternalStudioCertMode.KpiCode -> IInternalStudioCertInfoByKpiCode
  readonly CertInfo: string;

  readonly CreatorBy: string; // userID
  readonly ModifierBy: string | null;
  readonly CreateTime: string;
  readonly ModifyTime: string;
}

export enum StudioCertifiedType {
  Company = 'company',
  InternalKpiCode = 'internalKpiCode',
}

export interface IInternalStudioCertifiedModel {
  readonly id: number;
  readonly StudioID: string;

  // 待审批0，认证成功1，拒绝或者下线2
  readonly Status: CommonStatusStep;

  readonly ApproverBy: string | null; // 首次创建人 userID
  readonly ModifierBy: string | null;

  readonly CreatorBy: string;

  readonly RejectReason?: string; // 拒绝原因

  readonly CertInfo: string;

  readonly CreateTime: string;
  readonly ModifyTime: string;
}

export enum InternalStudioCertMode {
  KpiCode = 0,
}
// 内部工作室，用户认证记录 start -----------------------------
export interface IInternalStudioUserCertRecordModel {
  readonly id: number;
  readonly StudioID: string;

  // 认证模式，目前内部认证只有kpi code，既默认
  readonly CertMode: InternalStudioCertMode;

  // 认证模式具体的填写信息 json string
  // InternalStudioCertMode.KpiCode -> IInternalStudioCertInfoByKpiCode
  readonly CertInfo: string;

  readonly CreatorBy: string; // userID
  readonly ModifierBy: string | null;
  readonly CreateTime: string;
  readonly ModifyTime: string;
}

export type IAPICompanyFullInfo = {
  id: number;
  StudioID: string;
  Name?: string; // 企业名称
  Region?: 'cn'; // 企业地区
  Description?: string; // 企业描述
  Type?: CompanyType; // 身份 自研/二方/投后
  Status: CommonStatusStep;
  CreditCode?: string; // 社会信用代码
  BusinessLicenseImageUrl?: string; // 营业执照文件
  Contacts?: string; // json 联系人姓名、手机号、身份证
  CreatorBy?: string;
  ModifierBy?: string | null;
  CreateTime?: string;
  ModifyTime?: string;

  RejectReason?: string;
  MDMStatus?: MDMAuthStatus;
  ManualStatus?: CommonStatusStep;
  ManualRejectReason?: string;
  MDMRejectReason?: string;
  MDMCertificationInfo?: string;

  InternalCertInfo?: ICertInfo;
  studioCertRes?: IInternalStudioCertifiedModel;
  lastCertifiedType?: StudioCertifiedType;
  certifiedType?: StudioCertifiedType;
  isCertified?: boolean;
  mdmUnderReview?: boolean;
};

interface IAPICompanyApprovalInfo {
  id: number;
  StudioID: string;
  ManualStatus: CommonStatusStep;
  ManualRejectReason: string;
  MDMStatus: MDMAuthStatus;
  MDMRejectReason: string;
  MDMFirstApproval: null;
  Approver: string;
  CreateTime: string;
  ModifyTime: string;
}

// 企业信息
export interface IAPICompanyInfo {
  id: number;
  StudioID: string;
  Name?: string; // 企业名称
  Region?: 'cn'; // 企业地区
  Description?: string; // 企业描述
  Type?: CompanyType; // 身份 自研/二方/投后
  Status: CommonStatusStep;
  CreditCode?: string; // 社会信用代码
  BusinessLicenseImageUrl?: string; // 营业执照文件
  Contacts?: string; // json 联系人姓名、手机号、身份证
  CreatorBy: string;
  ModifierBy: string | null;
  CreateTime: string;
  ModifyTime: string;
  MDMCertificationInfo?: string;

  RejectReason?: string;
}

export interface ICertInfo {
  productCode: string;
  productName: string;
  projectName: string;
  projectOwner: string;
}

export interface ICreateCompanyBody {
  studioID: string;
  name: string; // 企业名称
  description: string; // 企业描述
  creditCode: string; // 社会信用代码
  businessLicenseImageUrl: string; // 营业执照文件
  contacts: string; // json 联系人姓名、手机号、身份证
  adminApplyLink: string;
}

export interface ICreateInternalCompanyBody {
  studioID: string;
  projectName: string;
  projectOwner: string;
  kpiCode: string;
  kpiCodeName?: string;
}

export interface ICrosProductListItem {
  // readonly product_code: string;
  // readonly product_name: string;

  // 需要对外盘点有效的数据  就是 cros_check = 1
  // readonly cros_check: 0 | 1;

  // readonly dept_path_cn: string;
  code: string;
  name: string;
}
